import styled from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
`

export const Details = styled(Text)`
  color: ${props => props.theme.colors.text.muted};
`
